var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.835 0.5H2.16833C1.24917 0.5 0.501667 1.2475 0.501667 2.16667V5.5H2.16833V2.16667H13.835V13.8333H2.16833V10.5H0.501667V13.8333C0.501667 14.7525 1.24917 15.5 2.16833 15.5H13.835C14.7542 15.5 15.5017 14.7525 15.5017 13.8333V2.16667C15.5017 1.2475 14.7533 0.5 13.835 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16667 11.3333L11.3333 8L7.16667 4.66667V7.1675H0.5V8.83417H7.16667V11.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutNav);
export default __webpack_public_path__ + "static/media/logoutNav.31e23357e16df91f87fe063cec5e612b.svg";
export { ForwardRef as ReactComponent };